// extracted by mini-css-extract-plugin
module.exports = {"tabs":"zone-module--tabs--ppBeW","mainCard":"zone-module--mainCard--AkBBL","titleWrapper":"zone-module--titleWrapper--E5wYY","printButton":"zone-module--printButton--20WvB"};